import {
  Button,
  ButtonElementTypes,
  ButtonSkinPrimary,
  ButtonVariants,
} from '@picsart/design-system/components/Button';
import { useTranslator } from '@picsart/rc/services/localization';
import useStyles from './styles';
import { ShowAllProps } from './types';

const ShowAll = ({ title, redirectUrl, bannerTitle }: ShowAllProps) => {
  const classes = useStyles();
  const translate = useTranslator();

  return (
    <Button
      dataTestId={`${bannerTitle} - show-all`}
      data-pulse-name={`${bannerTitle} - show-all`}
      variant={ButtonVariants.Text}
      tag={ButtonElementTypes.Link}
      skin={ButtonSkinPrimary}
      className={classes.showAll}
      href={redirectUrl}
    >
      {translate(title)}
    </Button>
  );
};

export default ShowAll;
